import React from 'react';
import {connect} from 'react-redux'
import AppNotificationItem from './AppNotificationItem'
const AppNotification = (props) => {
    const {notifications} = props
    return (
        <div>
        {Object.keys(notifications).map(key =>
            <AppNotificationItem notification={notifications[key]} key={key}/>
            
        )}
        
        </div>
    )
}

const mapStateToProps = (state) =>({
    notifications: state.notificationState.notifications
})

export default connect(mapStateToProps)(AppNotification)


// WEBPACK FOOTER //
// ./src/Components/Notification/AppNotification.js